(function (global) {
  'use strict';
  if (global.CeikaSpareEnquiries?.version === 1) {
    global.CeikaSpareEnquiries.scan();
    return;
  }

  function mounting(choices, axle) {
    const side = choices['floating-' + axle];
    const key = side || choices['floating-both'] || choices['floating-single'];
    if (key === 'standard-2-pcs-alloy') return 'fixed';
    if (key === 'full-floating-h-type-anti-rattle-front-rear' ||
        key === 'full-floating-h-type-anti-rattle-front-or-rear-only') return 'floating';
    if (key === 'full-floating-h-type-anti-rattle-front-only') return axle === 'front' ? 'floating' : 'fixed';
    if (key === 'full-floating-h-type-anti-rattle-rear-only') return axle === 'rear' ? 'floating' : 'fixed';
    return '';
  }

  function matches(context, map) {
    const rows = [];
    for (const axle of ['front', 'rear']) {
      const part = context?.hardware?.[axle];
      if (!part || typeof part.reference !== 'string' || !part.reference) continue;
      const row = map?.[part.reference];
      const fit = row && row.axle === axle && row.diameter === part.diameter && row.thickness === part.thickness;
      const mount = mounting(context.selected || {}, axle);
      rows.push({
        axle, ref: part.reference, diameter: part.diameter, thickness: part.thickness, mount,
        pad: fit && row.pad === part.padFamilyReference ? row.pad : null,
        ring: fit && !(mount === 'floating' && !row.floating) ? row.ring : null
      });
    }
    return rows;
  }

  function productContext(root) {
    const selected = root?.querySelector('[data-pilot-variant]')?.value;
    const e = root?.extrasController?.engine;
    const canonical = id => String(e?.catalog?.variantAliases?.[id] || id);
    if (!selected || !e?.variant || canonical(selected) !== canonical(e.variant.id) ||
        root.dataset.nativeError === 'true' || !e.hardwareState?.orderableHardware || e.hardwareState.blockers?.length) return null;
    const choices = {};
    for (const s of e.selection()) if (s.optionKey.startsWith('floating-')) choices[s.optionKey] = e.selected[s.optionKey];
    return {hardware:e.hardwareState.hardware, selected:choices};
  }

  function route(path, row, preview, origin, kind) {
    if (!path) return null;
    const url = new URL(path, origin);
    if (url.origin !== origin || !/\/products\/[^/]+$/.test(url.pathname)) return null;
    url.searchParams.set('ceika_spare_hw', row.ref);
    url.searchParams.set('ceika_spare_axle', row.axle);
    if (kind === 'rings' && row.mount) url.searchParams.set('ceika_spare_mount', row.mount);
    if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }

  function render(panel, rows) {
    const d = panel.dataset, list = panel.querySelector('[data-spare-cards]');
    list.replaceChildren();
    panel.querySelector('[data-spare-pending]').hidden = rows.length > 0;
    for (const row of rows) {
      const item = document.createElement('div'), spec = document.createElement('strong');
      spec.textContent = [d[row.axle], row.ref, row.diameter + ' × ' + row.thickness + ' mm', d[row.mount]].filter(Boolean).join(' · ');
      item.append(spec);
      for (const kind of ['pads','rings']) {
        const match = kind === 'pads' ? row.pad : row.ring;
        // Nominal ring dimensions never prove the bolt circle or hat interface.
        const path = kind === 'pads' && match && route(d.padsUrl, row, d.previewThemeId, location.origin, kind);
        const p = document.createElement('p'), a = document.createElement('a');
        const label = kind === 'pads' ? d.padLabel : d.ringLabel;
        const description = kind === 'pads' ? row.pad : row.ring?.replace(/^ring-/, '').toUpperCase();
        a.textContent = [path ? label : d.confirm + ' · ' + label, description].filter(Boolean).join(' — ');
        if (path) a.href = path;
        else {
          const contact = new URL(d.contactUrl, location.origin);
          contact.searchParams.set('ceika_template','1');
          contact.searchParams.set('inquiry','General & Ordering');
          contact.searchParams.set('family','bbk');
          contact.searchParams.set('product',d.productUrl);
          contact.searchParams.set('request',[label,d.productTitle,spec.textContent,description].filter(Boolean).join('\n'));
          if (/^\d+$/.test(d.previewThemeId || '')) contact.searchParams.set('preview_theme_id',d.previewThemeId);
          contact.hash = 'ceika-contact-form';
          a.href = contact.href;
        }
        const image = d[kind + 'Image'];
        if (image) {
          const thumb = document.createElement('img');
          thumb.src = image;
          thumb.alt = '';
          thumb.loading = 'lazy';
          thumb.width = 48;
          thumb.height = 48;
          p.append(thumb);
        }
        p.append(a);
        item.append(p);
      }
      list.append(item);
    }
  }

  const maps = new Map();
  function attach(panel) {
    if (panel.dataset.spareBound) return;
    const line = panel.querySelector('template[data-line-context]');
    // Never fall through to a nearby product's selection for a cart row.
    const root = line ? null : panel.closest('.ceika-product-pilot,.shopify-section')?.querySelector('ceika-native-configurator');
    if (!root && !line) return;
    panel.dataset.spareBound = 'true';
    let saved;
    if (line) {
      try { saved = JSON.parse(line.content.textContent); } catch { return; }
    }
    let map = {};
    const update = () => render(panel, matches(line ? saved : productContext(root), map));
    const schedule = () => global.requestAnimationFrame(update);
    for (const evt of ['ceika:total','input','change']) root?.addEventListener(evt,schedule);
    const src = panel.dataset.map;
    if (!maps.has(src)) maps.set(src,fetch(src).then(r => r.ok ? r.json() : {}).catch(() => ({})));
    maps.get(src).then(result => {map = result; update();});
    update();
  }

  if (typeof module !== 'undefined') module.exports = {matches,mounting,productContext,route,render};
  if (!global.document) return;
  function scan() {document.querySelectorAll('[data-ceika-spare-enquiry]').forEach(attach);}
  global.CeikaSpareEnquiries = Object.freeze({version:1,scan});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  document.addEventListener('shopify:section:load',scan);
})(typeof window === 'undefined' ? globalThis : window);
